module.exports = __webpack_public_path__ + "img/logo_stacked.da4186fe.jpg";